import { render, staticRenderFns } from "./DepartmentOrdersChart.vue?vue&type=template&id=152b74ec&"
import script from "./DepartmentOrdersChart.vue?vue&type=script&lang=js&"
export * from "./DepartmentOrdersChart.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentOrdersChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports